import { Box, BoxProps } from "@mui/material";
import { ReactNode, forwardRef } from "react";

import { TypeHelper } from "@/common/helpers/type";

import AppChip, { AppChipProps } from "../../Chip/AppChip";
import AppPopover from "../../Popover/AppPopover";
import AppPopoverContent from "../../Popover/AppPopoverContent";
import { defaultTableCellContentOfChipProps } from "./TableCellContentOfChip";

export interface Props {
  count: number | undefined | null;
  variant?: AppChipProps["variant"];
  size?: AppChipProps["size"];
  color?: AppChipProps["color"];
  shape?: AppChipProps["shape"];
  /** Detailed content that is shown in popover when counter is hovered. */
  popoverContent?: ReactNode;
  containerProps?: Partial<BoxProps>;
}

export default forwardRef<HTMLDivElement, Props>(function TableCellContentOfCount(
  { count, popoverContent, containerProps, ...chipProps }: Props,
  ref,
) {
  const chipPropsComputed = { ...defaultTableCellContentOfChipProps, ...chipProps };

  return (
    <AppPopover
      enabled={!!popoverContent}
      hoverBehavior={{ closeBehavior: "onTriggerOrContentMouseLeave" }}
      trigger={
        <Box {...containerProps}>
          {TypeHelper.isNil(count) ? (
            "-"
          ) : (
            <AppChip ref={ref} {...chipPropsComputed} label={count} />
          )}
        </Box>
      }
    >
      <AppPopoverContent>{popoverContent}</AppPopoverContent>
    </AppPopover>
  );
});
